import axios from 'axios';
import { refreshShoppingCart } from './shoppingCartRefreshRequested$';
import router from '@/router';

export function addToShoppingCart(shoppingCart, productId, quantity, ppwRecId, isConsignmentProduct = false) {
  if (shoppingCart === null) {
    throw 'ShoppingCart is empty';
  }

  var command = {
      customerId: shoppingCart.customerId,
      productId: productId,
      quantity: quantity,
      ppwRecId: ppwRecId,
      isConsignmentProduct: isConsignmentProduct
  };

  return axios
    .post('ShoppingCart/AddToShoppingCart', command)
    .then((response) => {
      refreshShoppingCart();
      window.dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          item_list_name: router.currentRoute.value.path,
          items: [
            {
              item_id: response.data.ProductId,
              item_name: response.data.ProductName,
              item_brand: response.data.BrandOwner,   
              quantity: quantity
            }
          ]
        }
      });
      return response;
    });
}
